export enum RevenuesTypeRef {
  savings = 'savings',
  solar_monthly_fee = 'solar_monthly_fee',
  solar_monthly_fee_by_value= "solar_monthly_fee_by_value",
  ppa = 'ppa'
}

export enum ProjectFinancingStructureTypeRef {
  associated_to_the_affiliate = 'associated_to_the_affiliate',
  spv_spe = 'spv_spe'
}

export enum DepreciationTypeRef {
  sln = 'sln',
  db = 'db',
  vdb = 'vdb',
  progressive  = 'progressive'
}

export enum DepreciationTypeRefOther {
  sln = 'sln',
  db = 'db',
  vdb = 'vdb'
}

export enum DepreciationTypeRefUpp {
  sln = 'sln',
  progressive  = 'progressive'
}

export enum GridPricingTypeRef {
  simple_pricing = "simple_pricing",
  complex_pricing = "complex_pricing",
  my_pricing = "my_pricing"
}

export enum FeedInPricingTypeRef {
  simple_pricing = 'simple_pricing',
  flexible_pricing = 'flexible_pricing'
}
